module.exports = __webpack_public_path__ + "img/icon_sms.5319ddeb.svg";